import * as SingleSelect from '@givebutter/primitives/single-select';

const NumberOperatorOptions = () => (
    <>
        <SingleSelect.Item value="gt">
            <SingleSelect.ItemText>Greater than</SingleSelect.ItemText>
        </SingleSelect.Item>
        <SingleSelect.Item value="lt">
            <SingleSelect.ItemText>Less than</SingleSelect.ItemText>
        </SingleSelect.Item>
        <SingleSelect.Item value="eq">
            <SingleSelect.ItemText>Equal to</SingleSelect.ItemText>
        </SingleSelect.Item>
    </>
);

export { NumberOperatorOptions };
